var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"about image-composition"},_vm._l((_vm.images),function(img){return _c('img',{attrs:{"src":_vm.transformImage(img.image, 1.5),"alt":img.image.alt}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }